import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../utils/firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import DashboardImport from "./DashboardImport";
import DashboardCharts from "./DashboardCharts";

const DashboardDataCheck: React.FC = () => {
  const [hasData, setHasData] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setHasData(false);
        setLoading(false);
        return;
      }
      try {
        const snap = await getDocs(
          collection(db, "users", user.uid, "clients")
        );
        setHasData(snap.size > 0);
      } catch (err) {
        console.error(err);
        setHasData(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="text-center">Chargement...</div>;
  }

  return hasData ? <DashboardCharts /> : <DashboardImport />;
};

export default DashboardDataCheck;
